export const DEVICE_TYPES = [
  { value: '', label: 'Terminal Billet' },
  { value: 'SMART_POS', label: 'Terminal Billet Smart' },
];
